<template>
  <b-card class="rounded">
    <b-row class="flex-nowrap">
      <b-col class="p-0" style="max-width: 200px;">
        <div
          class="p-3 hp-bg-color-black-20 hp-bg-color-dark-90 border-right hp-border-color-black-40 hp-border-color-dark-80"
        >
          <div class="hp-sidebar-container">
            <div class="hp-sidebar-header-menu">
              <sidebar-header />
              <ul>
                <sidebar-item :item="sidebarItem" />
              </ul>
            </div>

            <sidebar-footer />
          </div>
        </div>
      </b-col>
      <b-col class="p-0" >
        <b-container fluid fill-weight>
          <ProfileCard v-if="this.$route.params.card === 'profile'" />
          <StatsCard v-else-if="this.$route.params.card === 'stats'" />
          <BillingCard v-else-if="this.$route.params.card === 'billing'" />
          <PricingCard v-else />
        </b-container>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BAvatar,
  BButton,
  BLink,
  BCard,
  BInputGroup,
  BFormInput,
  BForm,
  BFormRow,
  BContainer,
} from "bootstrap-vue";

import ProfileCard from "./cards/Profile.vue";
import StatsCard from "./cards/Stats.vue";
import PricingCard from "./cards/PricingCard.vue";
import BillingCard from "./cards/billing";
import SidebarHeader from "./header";
import SidebarItem from "./item";
import SidebarFooter from "./footer";
import navigation from "./routes";

export default {
  data() {
    return {
      sidebarItem: navigation,
      card: "",
    };
  },
  components: {
    BRow,
    BCol,
    BAvatar,
    BButton,
    BLink,
    BCard,
    SidebarHeader,
    SidebarItem,
    SidebarFooter,
    BInputGroup,
    BFormInput,
    BForm,
    BFormRow,
    ProfileCard,
    StatsCard,
    PricingCard,
    BillingCard,
    BContainer,
  },
};
</script>
